import React, { useState } from "react";
import { 
    Card, CardActions, CardContent, CardHeader, 
    IconButton, TextField, List, ListItem, 
    Checkbox, FormControlLabel, FormGroup, 
    Divider, Grid, Fab, Typography, Popover
} from "@material-ui/core";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { createMarkup, remoteURL, scrollTop } from "../common";
import ModalImages from "../components/ModalImages";
import ReactCardFlip from 'react-card-flip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faInfo, faInfoCircle
} from '@fortawesome/free-solid-svg-icons'

import { isIOS, isAndroid } from 'react-device-detect';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { LabsComponent } from "./LabComponent";
import { ReviewSlider } from "./ReviewSlider";

import "../styles/masterStyles.css";
import { Redirect } from "react-router";

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 345,
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    }
}));

export const RetiredQuestionTestCard = props => {
    const referenceURI = 'https://university.auanet.org/mobileapps/sasp/resources/references.cfm?questionid=' + props.obj.questionID + '&questionnumber=' + props.obj.questionNumber + '&id=' + props.mcid + '&key=' + props.mykey;

    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);
    const [flipped, setFlipped] = React.useState(false);

    const [answer, setAnswer] = useState(null);
    const [answerid, setAnswerID] = useState(null);
    const [correct, setCorrect] = useState(null);
    const [next, setNext] = useState(null);
    const [prev, setPrev] = useState(null);
    const correctObj = props.obj.qoptions.filter(item => item.AnswerOptionCorrect === 1);

    const _OBJ = {
        mcid: props.mcid,
        questionid: props.obj.questionID,
        key: props.mykey,
        year: props.year,
        gamemode: props.gamemode
    }

    let temp = props.deckList.find(item => item.deckID == props.deckID);
    let owner = 0;
    if (typeof temp !== 'undefined') {
        owner = Number(temp.owner);
    }

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [value, setValue] = useState('');

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const mapActionBtn = () => {
        let _submit = _OBJ;

        _submit.correct = 0;
        _submit.answerid = -1;

        for (const item of props.obj.qoptions) {
            if (item.AnswerOptionCorrect === 1) {
                _submit.correct = 1;
                _submit.answerid = item.AnswerOptionID;
                _submit.choice = item.AnswerOptionID;
                _submit.retired = {
                    nextquestionid: props.obj.nextQuestionID
                }

                break;
            }
        }

        return (
            <>
                <div></div>
                <div 
                    className="sasp-submit-btn"
                    onClick={() => {
                        return props.submitFunc(_submit)
                    }}
                >
                    Next
                </div>
                <div></div>
            </>
        )
    }

    let prevClass = 'firstButton ';
    let showPrev = 1;

    const handleNext = () => {
        let _next = _OBJ;
        _next.next = props.obj.nextQuestionID;

        return props.submitFunc(_next)
    }

    return (
        <>
            <ReactCardFlip isFlipped={flipped} flipDirection="horizontal" infinite={true} className="width100">
                <Card 
                    className="width100 margin-bottom-8"
                >
                    <CardHeader 
                        title={`SASP ${props.obj.QuestionYear} Question ${props.obj.questionNumber}`}
                        style={{
                            backgroundColor: "#f1f3f5"
                        }}
                    />
                    
                    <CardContent > 
                        <p>This question ({`SASP ${props.obj.QuestionYear} Question ${props.obj.questionNumber}`}) has been withdrawn.</p>

                        <p>Click 'Next' to continue.</p>
                    </CardContent>

                    <CardActions
                        style={{
                            display:"flex",
                            flexDirection:"row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "8px 16px",
                            backgroundColor: "#f1f3f5"
                        }}
                    >
                        {/* <IconButton
                            className={prevClass}
                            edge="start"
                            aria-label="firstIcon"
                            style={{opacity: '0.5', cursor: 'not-allowed'}}
                        >
                            <ArrowBackIcon />
                        </IconButton> */}

                        {mapActionBtn()}

                        {/* <IconButton
                            className={clsx(classes.expand, {
                                [classes.expandOpen]: expanded,
                            })}
                            onClick={() => handleNext()}
                        >
                            <ArrowForwardIcon />
                        </IconButton> */}
                    </CardActions>
                </Card>

                <Card 
                    className="width100 margin-bottom-8"
                >
                    <CardHeader 
                        title={`SASP ${props.obj.QuestionYear} Question ${props.obj.questionNumber}`}
                        style={{
                            backgroundColor: "#f1f3f5"
                        }}
                    />
                    
                    <CardContent > 
                        <p>This question ({`SASP ${props.obj.QuestionYear} Question ${props.obj.questionNumber}`}) has been withdrawn.</p>

                        <p>Click 'Next' to continue.</p>
                    </CardContent>

                    <CardActions
                        style={{
                            display:"flex",
                            flexDirection:"row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "8px 16px",
                            backgroundColor: "#f1f3f5"
                        }}
                    >
                        {/* <IconButton
                            className={prevClass}
                            edge="start"
                            aria-label="firstIcon"
                            style={{opacity: '0.5', cursor: 'not-allowed'}}
                        >
                            <ArrowBackIcon />
                        </IconButton> */}

                        {mapActionBtn()}

                        {/* <IconButton
                            className={clsx(classes.expand, {
                                [classes.expandOpen]: expanded,
                            })}
                            onClick={() => handleNext()}
                        >
                            <ArrowForwardIcon />
                        </IconButton> */}
                    </CardActions>
                </Card>
            </ReactCardFlip>
        </>
    );
};